
import CountryFlag from 'vue-country-flag-next'
import { defineComponent, ref, computed, getCurrentInstance } from "vue";
import { InviteUtils } from '@/utils/InviteUtils';
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import { useMeta } from 'vue-meta';
import { User } from '@/_models/User';
import { UserService } from "@/services/UserService";
import { GameUtils } from "@/utils/GameUtils";
import { countriesList } from '@/modules/countrylist';
import defaultImage from "@/assets/images/user.png";
import router from '@/router';

export default defineComponent({
  name: "viewGamerProfile",
  components: {
    CountryFlag
  },
  setup() {
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;
    let totalGames;
    const pages = ref(20);
    const currentPage = ref(1);
    const totalPages = ref(0);
    const route = useRoute();
    const store = useStore();
    const userObj = store.getters['auth/user'];
    const label = computed(() => {
      return store.getters['config/configLabel'];
    });
    const metaTitle = ref('MetaXar Gamer Profile');
    const metaDescription = ref('MetaXar Gamer Profile Description');
    useMeta({ title: metaTitle.value, description: metaDescription.value });
    const gamerName = ref('');
    const userEmail = ref('');
    const gamerTag = ref('');
    const dateJoined = ref('Jul. 14,2018');
    const dateVerified = ref('Jan. 03,2019');
    const countryUser = ref('USA');
    const countryCode = ref('');
    const rank = ref('Rookie');
    const websiteUrl = ref('');
    const discord = ref('');
    const twitter = ref('');
    const tournament = ref('-');
    const gamesPlayed = ref('5');
    const playTime = ref('234 hours');
    const games = ref([]);
    const invitedgames = ref([]);
    const displayGames = ref([]);
    const invitedGames = ref([]);
    const displayInvitedGames = ref([]);
    const assetURL = computed(() => {
      return store.getters['config/assetUrl'];
    });
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      (async () => {
        const userService = new UserService();
        const userDetail: User = await userService.getUser(route.params.gamerId.toString());
        if(!userDetail) {
          router.push('/invalid-user-id');
        }
        userEmail.value = userDetail.xarcadeUser.email;
        gamerTag.value = userDetail.xarcadeUser.userId;
        countryUser.value = userDetail.xarcadeUser.country;
        websiteUrl.value = userDetail.xarcadeUser.websiteUrl;
        discord.value = userDetail.xarcadeUser.socialMedia["discord"];
        twitter.value = userDetail.xarcadeUser.socialMedia["twitter"];
        const updated = new Date(userDetail.xarcadeUser.created);
        const updatedDate = month[(updated.getMonth() + 1)] + '. ' + ("0" + updated.getDate()).slice(-2) + ',' + updated.getFullYear();
        dateJoined.value = updatedDate;
        gamerName.value = userDetail.xarcadeUser.username;
        const favouriteGame = await GameUtils.fetchFavouriteGame();
        games.value = favouriteGame;
        displayGames.value = games.value;
        let found = countriesList.find(country => country.name === countryUser.value);
        countryCode.value = found ? found.code : 'n/a';

      const gameInvitation = new InviteUtils();
      invitedgames.value = await gameInvitation.fetchInvitedGames();
      invitedgames.value.forEach(game => {
        if (game.gameDto != null) {
          // console.log(game.gameDto)
          if (!invitedGames.value.includes(game.gameDto.gameId)) {
            invitedGames.value.push(game.gameDto.gameId);
            displayInvitedGames.value.push(game);
          }
        }
      })

      totalGames = invitedgames.value.length;
      totalPages.value = Math.ceil(totalGames / pages.value);
      displayInvitedGames.value = invitedgames.value.slice(
        (currentPage.value - 1) * pages.value,
        Number((currentPage.value - 1) * pages.value) + Number(pages.value)
      );
    })()

    const loadGames = () => {
      totalPages.value = Math.ceil(invitedgames.value.length / pages.value);
      displayInvitedGames.value = invitedgames.value.slice(
        (currentPage.value - 1) * pages.value,
        Number((currentPage.value - 1) * pages.value) + Number(pages.value)
      );
    };
    loadGames();

    const enableFirstPage = computed(() => {
      return currentPage.value > 1;
    });

    const enablePreviousPage = computed(() => {
      return currentPage.value > 1;
    });

    const enableNextPage = computed(() => {
      return totalPages.value - currentPage.value > 0;
    });

    const enableLastPage = computed(() => {
      return currentPage.value < totalPages.value;
    });

    const naviFirst = () => {
      currentPage.value = 1;
      loadGames();
    };

    const naviPrevious = () => {
      --currentPage.value;
      loadGames();
    };

    const naviNext = () => {
      ++currentPage.value;
      loadGames();
    };

    const naviLast = () => {
      currentPage.value = totalPages.value;
      loadGames();
    };

    const changeRows = () => {
      loadGames();
    };

    const openExternalWebsite = (website:string) => {
      emitter.emit('OPEN_EXTERNAL_WEBSITE', website);
    }

    const image = computed(() => {
      const userDataRefreshed = store.getters["auth/user"];
      return (userDataRefreshed.profilePicture)?assetURL.value + 'blob/users/' + userDataRefreshed.username + '/' + userDataRefreshed.profilePicture:defaultImage;
    });



    return {
      userObj,
      userEmail,
      gamerName,
      gamerTag,
      dateJoined,
      dateVerified,
      countryUser,
      countryCode,
      rank,
      websiteUrl,
      discord,
      twitter,
      tournament,
      gamesPlayed,
      playTime,
      games,
      image,
      label,
      assetURL,
      displayGames,
      invitedGames,
      displayInvitedGames,
      pages,
      currentPage,
      totalPages,
      enableFirstPage,
      enablePreviousPage,
      enableNextPage,
      enableLastPage,
      naviFirst,
      naviPrevious,
      naviNext,
      naviLast,
      changeRows,
      openExternalWebsite,
    }
  }
});
